import React from 'react';
import { mockData } from '../mock';

const DynamicAppShowcase = () => {
  return (
    <section className="py-20 bg-dark-gradient relative">
      {/* Background Effects */}
      <div className="absolute inset-0 bg-grid-pattern opacity-10"></div>
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <h2 className="heading-power mb-6 animate-slide-power">
            EXPERIENCE THE <span className="text-neon-green">POWER</span>
          </h2>
          <p className="text-energy max-w-3xl mx-auto animate-slide-power delay-200">
            See how our AI coach transforms every aspect of your life with intelligent, 
            relentless guidance that never backs down from your potential.
          </p>
        </div>

        {/* Dynamic Gallery */}
        <div className="relative">
          <div className="flex overflow-x-auto space-x-8 pb-8 scrollbar-hide">
            {mockData.appScreens.map((screen, index) => (
              <div 
                key={screen.id}
                className="flex-shrink-0 w-96 group animate-slide-power"
                style={{ animationDelay: `${index * 0.2}s` }}
              >
                <div className="relative bg-black rounded-3xl overflow-hidden shadow-2xl hover-lift hover-glow neon-border">
                  {/* Image with Gradient Overlay */}
                  <div className="aspect-[4/5] relative">
                    <img 
                      src={screen.image}
                      alt={screen.title}
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent"></div>
                    
                    {/* Glow Effect on Hover */}
                    <div className="absolute inset-0 bg-gradient-primary opacity-0 group-hover:opacity-20 transition-opacity duration-300"></div>
                  </div>

                  {/* Bold Content Overlay */}
                  <div className="absolute bottom-0 left-0 right-0 p-8">
                    <h3 className="heading-bold text-white mb-4 group-hover:text-neon-green transition-colors">
                      {screen.title}
                    </h3>
                    <p className="text-energy text-gray-300 mb-6">
                      {screen.description}
                    </p>
                    
                    {/* Power Button */}
                    <button className="bg-gradient-primary px-6 py-3 rounded-full text-white font-bold text-sm uppercase tracking-wide hover:shadow-lg hover:scale-105 transition-all">
                      TRY NOW
                    </button>
                  </div>

                  {/* Animated Border */}
                  <div className="absolute inset-0 rounded-3xl border-2 border-transparent group-hover:border-neon-green/50 transition-all duration-300"></div>
                </div>
              </div>
            ))}
          </div>

          {/* Gradient Overlays for Scroll */}
          <div className="absolute top-0 left-0 w-32 h-full bg-gradient-to-r from-black to-transparent pointer-events-none z-10"></div>
          <div className="absolute top-0 right-0 w-32 h-full bg-gradient-to-l from-black to-transparent pointer-events-none z-10"></div>
        </div>

        {/* Power CTA */}
        <div className="text-center mt-16">
          <button className="btn-power text-lg px-12 py-4 animate-pulse-power">
            UNLEASH YOUR POTENTIAL
          </button>
        </div>
      </div>
    </section>
  );
};

export default DynamicAppShowcase;